import React from 'react';
import { Autoplay, Pagination, Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import banner_1 from "../../../assets/img/Carousel/slide_1.jpg";
import banner_2 from "../../../assets/img/Carousel/slide_2.jpg";
import banner_3 from "../../../assets/img/Carousel/slide_3.jpg";
import banner_4 from "../../../assets/img/Carousel/slide_4.jpg";
import "./style.css";

function Slide() {
    return (
        <Swiper
            spaceBetween={30}
            centeredSlides={true}
            autoplay={{
                delay: 5000,
                disableOnInteraction: false
            }}
            pagination={{
                clickable: true
            }}
            navigation={{
                prevEl: '.swiper-button-prev',
                nextEl: '.swiper-button-next',
            }}
            modules={[Autoplay, Pagination, Navigation]}
            className="my_swiper"

        >
            <SwiperSlide>
                <img src={banner_1} alt="banner" className="img" />
            </SwiperSlide>

            <SwiperSlide>
                <img src={banner_2} alt="banner" className="img" />
            </SwiperSlide>

            <SwiperSlide>
                <img src={banner_3} alt="banner" className="img" />
            </SwiperSlide>

            <SwiperSlide>
                <img src={banner_4} alt="banner" className="img" />
            </SwiperSlide>

            <button className="swiper-button-prev">
                <span>Prev</span>
            </button>

            <button className="swiper-button-next">
                <span>Next</span>
            </button>
        </Swiper>
    );
}

export default Slide;


